<template>
    <div component="TableHead">
        <!-- {{config}} -->
        <table-cell v-for="cell in config" :key="config.id" :cell="cell" :text="cell.caption" v-if="showHeader">
            {{ cell.caption }}
        </table-cell>
    </div>
</template>

<script>
import TableCell from '@/components/.global/ScrollTable/TableCell.vue';

export default {
    name: 'TableHead',

    props: {
        config: {
            type: Array,
            required: true,
        },

        showHeader: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    components: {
        TableCell,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='TableHead'] {
    .flex-row;
    border-bottom: 1px solid @dark;
    margin-right: 20px;

    .cell {
        font-weight: 900;
        font-size: 13px;
        text-transform: uppercase;
        line-height: 1;
    }
}
</style>
